'use strict';

var prototypes = {
    /**
     * @function
     * @description init
     */
    init: function() {
        if (!Array.prototype.find) {
            // eslint-disable-next-line no-extend-native
            Array.prototype.find = function(predicate) {
                if (this === null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                // eslint-disable-next-line no-undefined
                return undefined;
            };
        }
    }
};
module.exports = prototypes;
